// ContentComposer Actions
// This store accumulates data from all agents for a composition session

export const ACCUMULATE_CONTENT_ANALYSIS_DATA =
  "ACCUMULATE_CONTENT_ANALYSIS_DATA";
export const ACCUMULATE_VISUAL_ASSETS_DATA = "ACCUMULATE_VISUAL_ASSETS_DATA";
export const ACCUMULATE_TEXT_CONTENT_DATA = "ACCUMULATE_TEXT_CONTENT_DATA";
export const ACCUMULATE_VIDEO_SEGMENTS_DATA = "ACCUMULATE_VIDEO_SEGMENTS_DATA";
export const CLEAR_CONTENT_COMPOSER_DATA = "CLEAR_CONTENT_COMPOSER_DATA";
export const SET_COMPOSITION_TICKET_ID = "SET_COMPOSITION_TICKET_ID";

// Action creators
export const accumulateContentAnalysisData = (data) => ({
  type: ACCUMULATE_CONTENT_ANALYSIS_DATA,
  payload: data,
});

export const accumulateVisualAssetsData = (data) => ({
  type: ACCUMULATE_VISUAL_ASSETS_DATA,
  payload: data,
});

export const accumulateTextContentData = (data) => ({
  type: ACCUMULATE_TEXT_CONTENT_DATA,
  payload: data,
});

export const accumulateVideoSegmentsData = (data) => ({
  type: ACCUMULATE_VIDEO_SEGMENTS_DATA,
  payload: data,
});

export const clearContentComposerData = () => ({
  type: CLEAR_CONTENT_COMPOSER_DATA,
});

export const setCompositionTicketId = (ticketId) => ({
  type: SET_COMPOSITION_TICKET_ID,
  payload: ticketId,
});
